module.exports = "<span [class]=\"'mat-caption status status--' + type\">\r\n  {{text}}\r\n</span>\r\n"